module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Stairs-090df7572b60058890a3c6dacaf81733.svg";